module.exports = __webpack_public_path__ + "img/symbol-swan-right.66a34b8c.png";